exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unread {\n  background: #f2f2f2; }\n\n.navbar-dropdown {\n  max-height: 400px;\n  overflow-y: auto; }\n\n.navbar-link.icon-link {\n  margin-left: 16px; }\n\n.tag {\n  border-radius: 100%;\n  position: relative;\n  top: -50%;\n  right: 30%; }\n\n@media only screen and (min-width: 960px) {\n  .icon-link {\n    padding-left: 0px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/activity/notification-list/notification-list.component.scss
// module id = ../../../../../src/app/activity/notification-list/notification-list.component.scss
// module chunks = 1